/* istanbul ignore file */
import React, { useContext, useMemo } from 'react';
import { getStoredAuthenticationToken } from 'infrastructure/security/authentication/tokenprovider/authenticationTokenRepository';

export type AuthenticationToken = Nullable<string>;

interface TokenContext {
  getToken: () => Promise<AuthenticationToken>;
}

interface DefaultTokenProviderProps {
  getToken: () => Promise<AuthenticationToken>;
  children: React.ReactNode;
}

const TokenReactContext = React.createContext<TokenContext>({
  getToken: () => Promise.resolve(getStoredAuthenticationToken()?.token || null),
});

export const useTokenProvider = () => useContext(TokenReactContext);

export const DefaultTokenProvider = ({ getToken, children }: DefaultTokenProviderProps) => {
  const contextValue = useMemo(
    () => ({
      getToken,
    }),
    [getToken],
  );

  return <TokenReactContext.Provider value={contextValue}>{children}</TokenReactContext.Provider>;
};
